import { useCustomerLocations } from 'hooks/useCustomerLocations';
import { useServiceFeatures } from 'hooks/useServiceContext';
import { TMSLocation } from 'types/Load';
import { Maybe, Undef } from 'types/UtilityTypes';
import { TMS } from 'types/enums/Integrations';

import { useQuickQuoteContext } from '../../context/QuickQuoteContext';

// Scopes the shared customer locations hook to the Tai integration and the LTL customer.
export function useTaiCustomerLocations(): {
  locations: Maybe<TMSLocation[]>;
  setLocations: React.Dispatch<React.SetStateAction<Maybe<TMSLocation[]>>>;
  isLoadingLocations: boolean;
  tmsID: Undef<number>;
  customerID: Undef<number>;
  customerExternalTmsId: Undef<string>;
  hasCustomer: boolean;
} {
  const { ltlCustomer } = useQuickQuoteContext();
  const { ltlTMSIntegrations } = useServiceFeatures();

  const taiTmsId = ltlTMSIntegrations?.find(
    (integration) => integration.name === TMS.Tai
  )?.id;
  const customerDbId = ltlCustomer?.customerDbId;
  const customerExternalId = ltlCustomer?.externalId ?? ltlCustomer?.customerId;

  const customerLocations = useCustomerLocations({
    tmsID: taiTmsId,
    customerID: customerDbId,
    customerExternalTmsId: customerExternalId,
  });

  return {
    ...customerLocations,
    tmsID: taiTmsId,
    customerID: customerDbId,
    customerExternalTmsId: customerExternalId,
  };
}
